<div id="electronic-billing-block-container">
  <div class="img-container">
        <img
          src="./../../../assets/images/jupiter-block/electronic-billing-block.png"
          alt=""
        />
  </div>
  <p class="title">
    Inconvenientes con los servicios de ARCA
  </p>
  <p class="legend">
    Te pedimos disculpas, en este momento los servicios de ARCA están
          presentando inconvenientes técnicos. Esto podría afectar algunas
          funcionalidades de nuestro sitio
  </p>
  <p class="legend">
    Te recomendamos intentar nuevamente en unos minutos. Agradecemos tu
    comprensión.
  </p>
    <qr-button id="button-reload"
    [config]="buttonReload"
    (click)="onReload()"
    ></qr-button>
    <qr-button
    [config]="home"
    (click)="onGoHome()"
    ></qr-button>
</div>
